import axios from '@/plugins/axios';
import utils from '@/stores/utils';
import documents from './submodules/documents';
import store from './store';

const state = {
    is_operator: false,

    receipt: {},
    receipt_saving: false,
    receipt_saving_errors: null,

    receipt_type: null,


    options: [],
    options_loading: false,
    options_loading_errors: null,

    providers: [],
    providers_count: 0,
    providers_loading: false,
    providers_loading_errors: null,

    stocks: [],
    stocks_count: 0,
    stocks_loading: false,
    stocks_loading_errors: null,
};

const mutations = {

    updateReceipt(state, receipt) {
        state.receipt = JSON.parse(JSON.stringify(receipt || {}));
        state.receipt_saving = false;
        state.receipt_saving_errors = null;

        if (!state.receipt.stock_owner) {
            state.receipt.stock_owner = 'owner';
        }

        if ((receipt.id && receipt.provider) ||
            (store.getters['session/stats'].providers && store.getters['session/current_entity_persona'] != "manufacturer")) {
            state.receipt_type = 'providerproducts';
        } else {
            state.receipt_type = 'products';
        }
        state.options = [];
        state.options_loading = false;
        state.options_loading_errors = null;
    },
    updateReceiptType(state, receipt_type) {
        state.receipt_type = receipt_type;
        if (receipt_type !== 'providerproducts') {
            state.receipt = { ...state.receipt, stock_owner: 'owner' };
        }
    },
    updateStock(state, stock) {
        state.receipt = { ...state.receipt, stock: stock };
    },
    updateOptions(state, options) {
        state.options = options;
    },
    updateOptionsLoading(state, deleting) {
        state.options_loading = deleting;
    },
    updateOptionsLoadingErrors(state, errors) {
        state.options_loading_errors = errors;
    },

    updateReceiptSaving(state, saving) {
        state.receipt_saving = saving;
    },
    updateReceiptSavingErrors(state, errors) {
        state.receipt_saving_errors = errors;
    },

    updateProvider(state, provider) {
        state.receipt = {
            ...state.receipt,
            provider: provider,
            stock_owner: provider
                ? state.receipt.stock_owner || 'owner'
                : 'owner',
        };
    },
    updateProductInventoryOwner(state, stock_owner) {
        state.receipt = { ...state.receipt, stock_owner };
    },
    updateProviders(state, providers) {
        state.providers = providers;
    },
    updateProvidersLoading(state, loading) {
        state.providers_loading = loading;
    },
    updateProvidersLoadingErrors(state, errors) {
        state.providers_loading_errors = errors;
    },

    updateStocks(state, stocks) {
        state.stocks = stocks;
        if (!state.receipt.stock && stocks.length == 1) {
            let main_stock = state.stocks.find((stock) => stock.main) || state.stocks[0];
            state.receipt.stock = main_stock.id;
        }
    },
    updateStocksLoading(state, loading) {
        state.stocks_loading = loading;
    },
    updateStocksLoadingErrors(state, errors) {
        state.stocks_loading_errors = errors;
    },


    toggleOption(state, catalogentry) {
        if (!state.receipt.options) {
            state.receipt.options = [];
        }
        if (!state.receipt.options.find((item) => catalogentry.id == item.catalogentry)) {
            if (!state.receipt.options) {
                state.receipt.options = [];
            }
            state.receipt.options.push({ catalogentry: catalogentry.id });
        } else {
            state.receipt.options = state.receipt.options.filter((item) => catalogentry.id != item.catalogentry);
        }
    }
};

const actions = {

    init({ commit, dispatch, state }, params) {
        commit('updateReceipt', params.receipt);
        dispatch('fetchProviders');
        dispatch('fetchStocks');
        dispatch('fetchOptions');
    },

    async fetchOptions({ commit, dispatch, state }, params) {

        if (!state.receipt.stock) {
            commit("updateOptions", []);
            return;
        }
        
        commit('updateOptionsLoading', true);
        commit('updateOptionsLoadingErrors', null);

        try {
            const response = await axios.get(`/api/stocks/${state.receipt.stock}/operatoroptionscatalogentries/`, {
                params: { trigger: "receipt-option", ordering: "label" }
            });
            commit('updateOptions', response.data.results);
            commit('updateOptionsLoading', false);
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateOptionsLoadingErrors', error.details);
            commit('updateOptionsLoading', false);
            throw error;
        }
    },

    async saveReceipt({ commit, dispatch, state }, params) {
        commit('updateReceiptSaving', true);
        commit('updateReceiptSavingErrors', null);

        let url = '/api/receipts/';
        let method = axios.post;
        const receipt = JSON.parse(JSON.stringify(state.receipt || {}));
        if (state.receipt_type == 'providerproducts') {
            receipt.provider = state.receipt.provider;
        } else {
            receipt.provider = null;
            receipt.stock_owner = 'owner';
        }
        if (receipt.id) {
            url = `/api/receipts/${receipt.receipt_id}/`;
            method = axios.put;
        }

        try {
            const response = await method(url, receipt);
            commit('updateReceiptSaving', false);
            await dispatch('session/fetchStats', null, { root: true });
            return response;
        } catch (xhr_error) {
            const error = utils.handleError(xhr_error);
            commit('updateReceiptSaving', false);
            commit('updateReceiptSavingErrors', error.details);
            await dispatch('session/fetchStats', null, { root: true });
            throw error;
        }
    },

    async fetchProviders({ commit, dispatch, state }, params) {
        commit('updateProvidersLoading', true);
        commit('updateProvidersLoadingErrors', null);

        try {
            const response = await axios.get('/api/providers/', {
                params: { limit: 1000, ordering: 'name', exclude_profile: "operator" },
            });
            commit('updateProviders', response.data.results);
            commit('updateProvidersLoading', false);
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateProvidersLoadingErrors', error.details);
            commit('updateProvidersLoading', false);
            throw error;
        }
    },

    changeStock({ commit, dispatch, state }, stock) {
        commit('updateStock', stock);
        dispatch('fetchOptions');
    },

    async fetchStocks({ commit, dispatch, state }, params) {
        commit('updateStocksLoading', true);
        commit('updateStocksLoadingErrors', null);

        try {
            const response = await axios.get('/api/stocks/', {
                params: { limit: 1000 },
            });
            commit('updateStocks', response.data.results);
            await dispatch('fetchOptions');
            commit('updateStocksLoading', false);
            return response;
        } catch (xhr_error) {
            let error = utils.handleError(xhr_error);
            commit('updateStocksLoadingErrors', error.details);
            commit('updateStocksLoading', false);
            throw error;
        }
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    modules: {
        documents: documents(),
    }
};
